<template>
  <div>
    <div class="row">
      <div class="col-md-5">
        <b-form>
          <div class="row">
            <h5 class="mb-3">E-mail</h5>
          </div>
          <div class="row">
            <div class="col-md-8">
              <b-form-group label="Informe seu e-mail" label-for="tem_email">
                <input class="form-control"
                       ref="tem_email"
                       :class="{'is-invalid': $v.pessoa_email.tem_email.$error || email_existe}"
                       v-model="pessoa_email.tem_email" id="tem_email" type="email">
                <div v-if="$v.pessoa_email.tem_email.$error" class="invalid-feedback">
                  Informe um e-mail válido
                </div>
                <div v-if="email_existe" class="invalid-feedback">
                  E-mail já informado
                </div>
              </b-form-group>
            </div>
            <b-form-group label="'" class="text-white" label-for="tfo_numero">
              <button type="button" @click="addEmail" class="btn btn-dark"><i class="bx bx-plus"></i> Incluir</button>
            </b-form-group>
          </div>
        </b-form>
      </div>
      <div class="col-md-7">
        <b-form>
          <div class="row">
            <h5 class="mb-3">Telefone</h5>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Tipo" label-for="tet_codigo">
                <select id="tet_codigo" v-model="pessoa_telefone.tet_codigo" class="custom-select"
                        :class="{ 'is-invalid': $v.pessoa_telefone.tet_codigo.$error }"
                        type="text">
                  <option value=""></option>
                  <option v-for="t in telefone_tipo" v-bind:value="t"
                          v-bind:key="t.tab_codigo">
                    {{ t.tab_nome }}
                  </option>
                </select>
                <div v-if="$v.pessoa_telefone.tet_codigo.$error" class="invalid-feedback">
                  Informe o tipo
                </div>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Número" label-for="tfo_numero">
                <input class="form-control"
                       ref="tfo_numero"
                       v-mask="(pessoa_telefone.tet_codigo.tab_numero==='1')?'(##) ##### - ####':'(##) #### - ####?#'"
                       :class="{'is-invalid': $v.pessoa_telefone.tfo_contato.$error || telefone_existe}"
                       v-model="pessoa_telefone.tfo_contato" id="tfo_numero" type="text">
                <div v-if="$v.pessoa_telefone.tfo_contato.$error" class="invalid-feedback">
                  Informe um número
                </div>
                <div v-show="telefone_existe" class="invalid-feedback">
                  Número já informado
                </div>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Ramal" label-for="tfo_contato">
                <input class="form-control"
                       v-model="pessoa_telefone.tfo_numero"
                       id="tfo_contato" type="text">
              </b-form-group>
            </div>
            <b-form-group label="'" class="text-white" label-for="tfo_numero">
              <button type="button" @click="addTelefone" class="btn btn-dark"><i class="bx bx-plus"></i> Incluir
              </button>
            </b-form-group>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <div class="table-responsive">
          <h6 v-show="list_email.length < 1" class="text-danger">Necessário informar pelo menos um e-mail</h6>
          <table v-show="list_email.length > 0" class="table mb-0">
            <thead>
            <tr>
              <th>E-mail</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="e in list_email" v-bind:key="e.tem_email">
              <td>{{ e.tem_email }}</td>
              <td class="text-right">
                <button type="button" @click="removeEmail(e)" class="btn btn-outline-danger btn-sm"><i
                    class="bx bxs-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-7">
        <div class="table-responsive">
          <h6 v-show="list_telefone.length < 1" class="text-danger">Necessário informar pelo menos um telefone</h6>
          <table v-show="list_telefone.length > 0" class="table mb-0">
            <thead>
            <tr>
              <th>Tipo</th>
              <th>Núm.</th>
              <th>Ramal</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="e in list_telefone" v-bind:key="e.tfo_contato">
              <td>{{ e.tet_codigo.tab_nome }}</td>
              <td>
                <span v-if="e.tet_codigo.tab_numero===1">{{ e.tfo_contato | VMask('(##) ##### - ####') }}</span>
                <span v-else>{{ e.tfo_contato | VMask('(##) #### - ####?#') }}</span>
              </td>
              <td>{{ e.tfo_numero }}</td>
              <td class="text-right">
                <button type="button" @click="removeTelefone(e)" class="btn btn-outline-danger btn-sm"><i
                    class="bx bxs-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {required, email} from "vuelidate/lib/validators";
import {soNumeros} from "@/helps/util";

export default {
  components: {},
  props: {
    telefone_tipo: {
      type: Array,
      default: function () {
        return [];
      },
    },
    list_email: {
      type: Array,
      default: function () {
        return [];
      },
    },
    list_telefone: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      pessoa_email: {
        tem_codigo: null,
        tps_codigo: null,
        tem_email: ""
      },
      pessoa_telefone: {
        tfo_codigo: null,
        tps_codigo: null,
        tet_codigo: "",
        tfo_contato: "",
        tfo_numero: "",
      },
      email_existe: false,
      telefone_existe: false
    };
  },
  validations: {
    pessoa_email: {
      tem_email: {
        required,
        email
      },
    },
    pessoa_telefone: {
      tet_codigo: {
        required,
      },
      tfo_contato: {
        required,
      },
    },
  },
  methods: {
    addEmail() {
      this.$v.pessoa_email.$touch();
      if (this.$v.pessoa_email.$invalid) {
        return false
      }
      this.email_existe = false;
      if (this.list_email.filter(e => e.tem_email.toLocaleLowerCase().indexOf(this.pessoa_email.tem_email.toLocaleLowerCase()) > -1).length > 0) {
        this.email_existe = true;
        return false;
      }
      this.list_email.push(this.pessoa_email);
      this.pessoa_email = {
        tem_codigo: null,
        tps_codigo: null,
        tem_email: ""
      }
      this.$v.pessoa_email.$reset()
      this.$refs.tem_email.focus();
    },
    addTelefone() {
      this.$v.pessoa_telefone.$touch();
      if (this.$v.pessoa_telefone.$invalid) {
        return false
      }
      this.telefone_existe = false;
      if (this.list_telefone.filter(t => soNumeros(t.tfo_contato).indexOf(soNumeros(this.pessoa_telefone.tfo_contato)) > -1).length > 0) {
        this.telefone_existe = true;
        return false;
      }
      this.list_telefone.push(this.pessoa_telefone);
      this.pessoa_telefone = {
        tfo_codigo: null,
        tps_codigo: null,
        tet_codigo: "",
        tfo_contato: "",
        tfo_numero: "",
      }
      this.$v.pessoa_telefone.$reset()
      this.$refs.tfo_numero.focus();
    },
    removeEmail(email) {
      this.list_email.pop(email);
    },
    removeTelefone(telefone) {
      this.list_telefone.pop(telefone);
    }
  }
};
</script>

